import React from "react";

export default class SearchBar extends React.Component {
    handleSearchUpdate = event => {
        if (event.key === "Enter") {
            this.props.updateSearchQuery(event.target.value);
        }
    };

    render() {
        let brandfolder_name = this.props.selected_brandfolder.attributes.name;
        return (
            <input
                className="adobe-search-bar"
                onKeyPress={this.handleSearchUpdate}
                placeholder={`Search ${brandfolder_name}`}
            />
        );
    }
}
